import { useEffect } from "react"


export default function ProtectedContent({ children, watermark }) {

  useEffect(() => {
    function preventKeyboardAction(event) {
      const key = event.key.toLowerCase();
      if ((event.ctrlKey || event.metaKey) && ['c', 'p', 's', 'u'].includes(key)) {
        event.preventDefault();
      }
    }

    document.addEventListener('keydown', preventKeyboardAction);

    return () => {
      document.removeEventListener('keydown', preventKeyboardAction);
    }
  }, [])

  return (
    <div
      className="protected-content"
      onContextMenu={(event) => event.preventDefault()}
      onCopy={(event) => event.preventDefault()}
      onCut={(event) => event.preventDefault()}
      onDragStart={(event) => event.preventDefault()}
    >
      <div className="protected-content-body">
        {children}
      </div>
      <div className="protected-content-watermarks" aria-hidden="true">
        {
          Array.from({ length: 12 }).map((item, index) => {
            return <span key={index}>{watermark}</span>
          })
        }
      </div>
    </div>
  )
}
